/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Guess_Label_CountryInputs */

const bn_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দেশটি অনুমান করুন`)
};

const de_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erraten Sie das Land`)
};

const el_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μαντέψτε τη χώρα`)
};

const en_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guess the country`)
};

const es_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adivina el pais`)
};

const fr_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devinez le pays`)
};

const hi_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देश का अंदाज़ा लगाओ`)
};

const hu_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Találd ki az országot`)
};

const id_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebak negaranya`)
};

const it_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indovina il paese`)
};

const ja_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国を推測してください`)
};

const ko_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나라를 맞춰보세요`)
};

const nl_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raad het land`)
};

const pl_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgadnij kraj`)
};

const pt_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adivinhe o país`)
};

const ru_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Угадай страну`)
};

const sv_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gissa landet`)
};

const tr_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülkeyi tahmin et`)
};

const uk_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вгадай країну`)
};

const vi_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đoán đất nước`)
};

const zh_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猜猜国家`)
};

const zh_hant_game_guess_label_country = /** @type {(inputs: Game_Guess_Label_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猜猜國家`)
};

/**
* | output |
* | --- |
* | "Guess the country" |
*
* @param {Game_Guess_Label_CountryInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_guess_label_country = /** @type {((inputs?: Game_Guess_Label_CountryInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Guess_Label_CountryInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_guess_label_country(inputs)
	if (locale === "de") return de_game_guess_label_country(inputs)
	if (locale === "el") return el_game_guess_label_country(inputs)
	if (locale === "en") return en_game_guess_label_country(inputs)
	if (locale === "es") return es_game_guess_label_country(inputs)
	if (locale === "fr") return fr_game_guess_label_country(inputs)
	if (locale === "hi") return hi_game_guess_label_country(inputs)
	if (locale === "hu") return hu_game_guess_label_country(inputs)
	if (locale === "id") return id_game_guess_label_country(inputs)
	if (locale === "it") return it_game_guess_label_country(inputs)
	if (locale === "ja") return ja_game_guess_label_country(inputs)
	if (locale === "ko") return ko_game_guess_label_country(inputs)
	if (locale === "nl") return nl_game_guess_label_country(inputs)
	if (locale === "pl") return pl_game_guess_label_country(inputs)
	if (locale === "pt") return pt_game_guess_label_country(inputs)
	if (locale === "ru") return ru_game_guess_label_country(inputs)
	if (locale === "sv") return sv_game_guess_label_country(inputs)
	if (locale === "tr") return tr_game_guess_label_country(inputs)
	if (locale === "uk") return uk_game_guess_label_country(inputs)
	if (locale === "vi") return vi_game_guess_label_country(inputs)
	if (locale === "zh") return zh_game_guess_label_country(inputs)
	return zh_hant_game_guess_label_country(inputs)
});